import { dnsResolver } from "./dnsResolver";

type Init = RequestInit & { headers?: HeadersInit };

export async function fetchSmart(input: string | URL, init: Init = {}) {
  const url = typeof input === "string" ? new URL(input) : input;

  console.log("🔍 fetchSmart received URL:", url.toString());
  console.log("🔍 Protocol:", url.protocol);
  console.log("🔍 Hostname:", url.hostname);

  // If HTTPS, let system DNS handle it
  if (url.protocol === "https:") {
    console.log("🔒 HTTPS detected - using system DNS:", url.toString());
    return fetch(url, init);
  }

  // Only HTTP from here
  const domain = url.hostname;
  let ip: string | undefined;

  console.log("🌐 HTTP detected - attempting custom DNS for:", domain);

  try {
    ip = await dnsResolver.resolveDomain(domain);
  } catch (error) {
    console.warn("❌ Custom DNS failed, falling back to system DNS:", error);
  }

  // If we couldn't resolve, use original URL
  if (!ip) {
    console.log("📝 Using original URL (DNS resolution failed)");
    return fetch(url, init);
  }

  // Build new URL with IP
  const newUrl = new URL(url.toString().replace(domain, ip));
  console.log("✅ DNS resolved:", domain, "→", ip);
  console.log("🔧 Final URL:", newUrl.toString());

  // Clone/merge headers and inject Host
  const headers: HeadersInit =
    init.headers instanceof Headers ? init.headers : new Headers(init.headers || {});
  headers.set("Host", domain);

  const finalInit: Init = { ...init, headers };
  console.log("🏠 Added Host header:", domain);

  console.log("newUrl", newUrl, finalInit);

  console.log("🏠 Added Host header:", domain);
  console.log("headers instance of Headers?", headers instanceof Headers);

  return fetch(newUrl, finalInit);
}
